import { call, delay, put, takeLatest } from "redux-saga/effects";

import { startLoader, stopLoader } from "../../../../utils/commonFunctions";

// for toast
import { toast } from "react-toastify";

import { PickupRequestActionTypes, PickupRequestActions } from "../../../actionTypes/operations/pickupRequestTypes";
import { setPostApiStatus, setPutApiStatus } from "../../../actions/apiStatusActions";
import { createPickupRequestApi,editPickupRequestDataByIdApi, getPickupRequestDataByIdApi, getPickupRequestListApi } from "../../requests/operations/pickupRequestRequests";
import { getPickupRequestList, setPickupRequestDataById, setPickupRequestList, setPickupRequestListCount } from "../../../actions/operations/pickupRequestAction";



function* createPickupRequestHandler(action: PickupRequestActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(createPickupRequestApi, action.payload);

    if (data.status) {
      // toast message
      toast.success(data?.message, {
        position: "top-right",
      });
      yield put(setPostApiStatus(true));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPostApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

function* getPickupRequestListHandler(action: PickupRequestActionTypes) {
  yield delay(500); //to hit search api after 500ms of the last key stroke
  try {
    yield startLoader("transparent");

    const { data } = yield call(getPickupRequestListApi, action.payload);

    if (data.status) {
      yield put(setPickupRequestList(data?.data?.rows));
      yield put(setPickupRequestListCount(data?.data?.count ?? 0));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* getPickupRequestDataByIdHandler(action: PickupRequestActionTypes) {
  try {
    yield startLoader("transparent");
    const { data } = yield call(getPickupRequestDataByIdApi, action.payload);
    if (data.status) {
      yield put(setPickupRequestDataById(data?.data));
    } else {
      toast.error(data?.message, {
        position: "top-right",
      });
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
  } finally {
    yield stopLoader("transparent");
  }
}

function* editPickupRequestDataByIdHandler(action: PickupRequestActionTypes) {
  try {
    yield startLoader("transparent");
   const { data } = yield call(editPickupRequestDataByIdApi, action.payload);  
    if (data.status) {
      toast.success(data.message || 'Pickup request updated successfully', {
        position: "top-right",
      });
      yield put(setPutApiStatus(true));
      yield put(getPickupRequestList({ page: 0, pageLimit: 10 }));
    }
  } catch (error: any) {
    toast.error(error?.response?.data?.message, {
      position: "top-right",
    });
    yield put(setPutApiStatus(false));
  } finally {
    yield stopLoader("transparent");
  }
}

// pickuprequest sagas
export default function* pickupRequestSaga() {
  yield takeLatest(PickupRequestActions.CREATE_PICKUP_REQUEST, createPickupRequestHandler);
  yield takeLatest(PickupRequestActions.GET_PICKUP_REQUEST_LIST, getPickupRequestListHandler)
  yield takeLatest(PickupRequestActions.GET_PICKUP_REQUEST_DATA_BY_ID, getPickupRequestDataByIdHandler);
  yield takeLatest(PickupRequestActions.EDIT_PICKUP_REQUEST_DATA_BY_ID, editPickupRequestDataByIdHandler);
}
